if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      // Start hidden until observer determines visibility
      this.classList.add('sticky-atc-panel--out');

      if ('IntersectionObserver' in window) {
        this.bindEvents();
      }
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            // Mobile: show sticky bar when the product form is NOT visible
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            // Desktop: show sticky bar when the product info is NOT visible
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      }, { threshold: 0 });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
